import axiosInstance from "../utils/axios";

// Books
export const fetchBooks = () => axiosInstance.get('/books/books/');
export const createBook = (bookData) => axiosInstance.post('/books/books/', bookData);
export const fetchBookDetail = (bookId) => axiosInstance.get(`/books/books/${bookId}/`);
export const updateBook = (bookId, bookData) => axiosInstance.put(`/books/books/${bookId}/`, bookData);
export const deleteBook = (bookId) => axiosInstance.delete(`/books/books/${bookId}/`);

// Chapters
export const fetchChaptersForBook = (bookId) => axiosInstance.get(`/books/books/${bookId}/chapters/`);
export const createChapter = (bookId, chapterData) => axiosInstance.post(`/books/books/${bookId}/chapters/`, chapterData);
export const fetchChapterDetail = (chapterId) => axiosInstance.get(`/books/chapters/${chapterId}/`);
export const updateChapter = (chapterId, chapterData) => axiosInstance.put(`/books/chapters/${chapterId}/`, chapterData);
export const deleteChapter = (chapterId) => axiosInstance.delete(`/books/chapters/${chapterId}/`);

// Image upload (already handled by ChapterEditor via its own call to /media/upload-image/)